function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.04 1.154a.438.438 0 01.666 0l2.902 3.237a.57.57 0 010 .744.438.438 0 01-.667 0l-2.096-2.34v8.442c0 .29-.212.526-.472.526s-.471-.236-.471-.526V2.796L1.805 5.135a.438.438 0 01-.667 0 .57.57 0 010-.744L4.04 1.154zm7.115 12.05V4.763c0-.29.212-.526.472-.526s.471.236.471.526v8.441l2.097-2.339a.438.438 0 01.667 0 .57.57 0 010 .744l-2.902 3.237a.438.438 0 01-.667 0l-2.901-3.237a.57.57 0 010-.744.438.438 0 01.667 0l2.096 2.34z",
  fill: "#2D2D2D"
});
function SvgSwitchvertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Switch vertical.svg";
export { SvgSwitchvertical as ReactComponent };